import { render, staticRenderFns } from "./CorporationInfoTab2.vue?vue&type=template&id=0294a93a"
import script from "./CorporationInfoTab2.vue?vue&type=script&lang=js"
export * from "./CorporationInfoTab2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0294a93a')) {
      api.createRecord('0294a93a', component.options)
    } else {
      api.reload('0294a93a', component.options)
    }
    module.hot.accept("./CorporationInfoTab2.vue?vue&type=template&id=0294a93a", function () {
      api.rerender('0294a93a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/CorporationInfoTab2.vue"
export default component.exports